import { Observable, pipe, of, EMPTY, from, Observer, throwError } from 'rxjs';
import { switchMap, catchError, mergeMap, map } from 'rxjs/operators';
import { Epic, ofType, ActionsObservable } from 'redux-observable';

import Axios, { AxiosPromise, AxiosResponse, AxiosError } from 'axios';
import { hopplerApi } from '../../../../constants/api';

import * as DashboardActions from './dashboard.actions'
import { DashboardAction } from './dashboard.actions';
import { DashboardMetricData, PotentialCommission } from '../../../../types/dashboard.model';

let dashboardEffects: Epic[] = [];

const getDashboardData: Epic = getDashboardData$ => getDashboardData$.pipe(
  ofType<DashboardAction>(DashboardActions.GET_DASHBOARD_DATA),
  switchMap(() => {

    let promise = Axios.get(`${hopplerApi.host}/kumita/partner-broker/dashboard`, {
      withCredentials: true
    });

    return from(promise).pipe(
      mergeMap((response) => {

        const metricData: DashboardMetricData = {
          listingCount: response.data.totalListingCount || 0,
          avgListingCount: response.data.listingsAverage || 0,
          viewsCount: response.data.totalViewsCount || 0,
          avgViewsCount: response.data.viewsAverage || 0,
          inquiriesCount: response.data.totalInquiriesCount || 0,
          avgInquiriesCount: response.data.inquiriesAverage || 0
        };

        const potentialCommission = response.data.potentialCommission;

        let salePotentialCommission: PotentialCommission;
        let rentalPotentialCommission: PotentialCommission;

        switch (potentialCommission) {

          case undefined:
          case null:
            salePotentialCommission = {
              onlineActive: 0,
              onlineOccupied: 0,
              offlineDrafts: 0,
              offlineDeclined: 0,
              offlinePending: 0,
              offlineExpired: 0,
            };
    
            rentalPotentialCommission = {
              onlineActive: 0,
              onlineOccupied: 0,
              offlineDrafts: 0,
              offlineDeclined: 0,
              offlinePending: 0,
              offlineExpired: 0,
            };
            break;

          default:
            salePotentialCommission = {
              onlineActive: potentialCommission.activeSaleCommission,
              onlineOccupied: potentialCommission.occupiedSaleCommission,
              offlineDrafts: potentialCommission.draftSaleCommission,
              offlineDeclined: potentialCommission.declinedSaleCommission,
              offlinePending: potentialCommission.pendingSaleCommission,
              offlineExpired: potentialCommission.expiredSaleCommission,
            };
    
            rentalPotentialCommission= {
              onlineActive: potentialCommission.activeRentCommission,
              onlineOccupied: potentialCommission.occupiedRentCommission,
              offlineDrafts: potentialCommission.draftRentCommission,
              offlineDeclined: potentialCommission.declinedRentCommission,
              offlinePending: potentialCommission.pendingRentCommission,
              offlineExpired: potentialCommission.expiredRentCommission,
            };
            break;
        }

        const topListingsByInquiries = response.data.topListingsByInquiries;
        const topListingsByViews = response.data.topListingsByViews;

        return of({
          type: DashboardActions.GET_DASHBOARD_DATA_SUCCESS,
          payload: {
            metricData: metricData,
            salePotentialCommission: salePotentialCommission,
            rentalPotentialCommission: rentalPotentialCommission,
            topListingsByInquiries: topListingsByInquiries,
            topListingsByViews: topListingsByViews
          }
        } as DashboardAction);
      }),
      catchError((errRes) => {
        console.error(errRes);

        return of({
          type: DashboardActions.GET_DASHBOARD_DATA_FAIL
        } as DashboardAction);
      })
    );

   
  })
);

const getBrokerLeaderboard: Epic = getBrokerLeaderboard$ => getBrokerLeaderboard$.pipe(
  ofType<DashboardAction>(DashboardActions.GET_BROKER_LEADERBOARD_DATA),
  switchMap(() => {

    let promise = Axios.get(`${hopplerApi.host}/kumita/partner-broker/dashboard/broker-leaderboard`, {
      withCredentials: true
    });

    return from(promise).pipe(
      mergeMap((response) => {
        
        const leaderboard =  response.data.results;
        

        return of({
          type: DashboardActions.GET_BROKER_LEADERBOARD_DATA_SUCCESS,
          payload: {
            brokerLeaderboard: leaderboard
          }
        } as DashboardAction);
      }),
      catchError((errRes) => {

        return of({
          type: DashboardActions.GET_BROKER_LEADERBOARD_DATA_FAIL
        } as DashboardAction);
      })
    );

   
  })
);

// ! Make sure to add created epics to array 

dashboardEffects.push(getDashboardData);
dashboardEffects.push(getBrokerLeaderboard);

export default dashboardEffects;